import { render, staticRenderFns } from "./OrgSettings.vue?vue&type=template&id=4871f8d0&"
import script from "./OrgSettings.vue?vue&type=script&lang=js&"
export * from "./OrgSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VDivider,VSkeletonLoader})
